import { SECONDARY_BG_COLOR } from 'shared/consts';
import styled, { css } from 'styled-components';

interface PanelStylesProps {
	$isOpen: boolean;
	$height?: string;
	$mediaHeight?: boolean;
	$maxHeight?: string;
	$includePadding?: boolean;
	$roundedBorders?: boolean;
	$background?: string;
  $minusHeight?: string;
}

export const PanelStyles = styled.div<PanelStylesProps>`
	background: ${props => props.$background || SECONDARY_BG_COLOR};
	z-index: 0;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	max-height: ${props => props.$maxHeight || 'initial'};
	height: ${props => props.$height || 'calc(100dvh - 164px)'};

	${props =>
		props.$roundedBorders &&
		css`
			border-radius: 24px;
		`};

	${props =>
		!props.$isOpen &&
		css`
			display: none;
		`}

	${props =>
		props.$includePadding &&
		css`
    padding-top: 16px;
    @media screen and (min-width: 767px) {
      padding: 4px 12px;
      padding-right: 0px;
    }
    @media screen and (max-width: 767px) {
      padding-left: 0px;
      padding-right: 0px;
    }
		`}

	${props =>
		props.$mediaHeight &&
		css`
			@media screen and (max-width: 580px) {
				max-height: 100dvh;
				height: calc(100dvh - ${props.$minusHeight || '147px'});
			}
		`}
`;
